export enum EnvironmentsEnum {
    DEFAULT = 'default',
    JUSTICE = 'justice',
    FINANCE = 'finance',
    MAGS_SOP = 'mags-sop',
    SH = 'sh',
    HMDJ = 'hmdj',
    BB_JM = 'bb-jm',
}
